import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_navigate_ud } from '@/hooks/_base/use_navigate_ud';
import { use_slice_collections, use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { remote_collection_get_shared_by_id } from '@/state/collection/entity/remote_collection_get_shared_by_id';
import { LOCAL__workspace_set_is_all_data_loaded } from '@/state/workspace/entity/LOCAL__workspace_set_is_all_data_loaded';
import { save_url_to_store_for_redirect_after_auth } from '@/utils/utils_client';
import { set_collection_current, set_current_workspace, try_set_default_workspace } from '@/utils/utils_client_workspace_child_entity_viewers';
import { try_load_shared_collection_from_server } from '@/utils/utils_shared_entity';
import { DTO_RESPONSE__success } from '@shared/network/DTO_RESPONSE__success';
import { useParams } from 'react-router-dom';

export function WatcherSlugPageCollections() {
  const dispatch = use_dispatch();
  const navigate = use_navigate_ud();
  let { collection_id: collection_id_from_slug } = useParams();

  const { auth_token } = use_slice_user(['auth_token']);
  const { collection_current, collections_map } = use_slice_collections(['collection_current', 'collections_map']);
  const { is_all_data_loaded, workspace_current } = use_slice_workspace(['is_all_data_loaded', 'workspace_current']);

  /*
   * EFFECTS
   */

  use_effect(() => {
    if (!is_all_data_loaded) return;

    //could be stub when from user deleted permissions to view entities
    let entity_id = collection_current.is_stub() ? '' : collection_current._id;

    let url_new = ENUM__page_type.BUILD_PATH_COLLECTIONS(entity_id);

    //sync slug with redux
    void navigate(url_new, { replace: true, keep_search_params: true });
  }, [collection_current]);

  use_effect(() => void set_entity_and_workspace_from_slug(), [is_all_data_loaded]);

  use_effect(() => void load_shared_entity_for_guest(), [auth_token]);

  /*
   * METHODS
   */
  async function set_entity_and_workspace_from_slug() {
    if (!auth_token) return; //not authorized
    if (!is_all_data_loaded) return; // not all data loaded

    if (collection_current._id == collection_id_from_slug && !collection_current.is_stub()) {
      //already equal
      return set_current_workspace(collection_current.workspace_id);
    }

    let entity_from_slug = [...collections_map.values()].find(item => item._id == collection_id_from_slug);

    if (!entity_from_slug && collection_id_from_slug) {
      entity_from_slug = await try_load_shared_collection_from_server(collection_id_from_slug);
    }

    if (entity_from_slug) {
      set_collection_current(entity_from_slug._id);

      set_current_workspace(entity_from_slug.workspace_id);
    } else if (workspace_current.is_stub()) {
      await try_set_default_workspace();
    }
  }

  async function load_shared_entity_for_guest() {
    if (auth_token) return; //user is authorized or going to authorize
    if (!collection_current.is_stub()) return; //already establshed

    if (!collection_id_from_slug) {
      //page without params
      //need save it and navigate to auth
      save_url_to_store_for_redirect_after_auth();

      await navigate(ENUM__page_type.AUTH);

      return;
    }

    let action_result = await dispatch(remote_collection_get_shared_by_id(collection_id_from_slug));

    if (action_result.payload instanceof DTO_RESPONSE__success) {
      let collection_current = set_collection_current(collection_id_from_slug);

      set_current_workspace(collection_current.workspace_id);

      dispatch(LOCAL__workspace_set_is_all_data_loaded(true));
    } else {
      save_url_to_store_for_redirect_after_auth();

      await navigate(ENUM__page_type.AUTH);
    }
  }

  return <></>;
}
